import { useCallback } from 'react';
import { useUpdateCollectionMutation } from '@/store/api';
/**
 * Platform-services hook for updating an existing collection.
 *
 * Wraps the RTK Query `useUpdateCollectionMutation` hook and exposes a
 * technology-agnostic contract.
 *
 * @see src/store/api/cc/collectionsApi.ts
 */
export const useUpdateCollection = () => {
    const [trigger, { data, isLoading, isError, error, }] = useUpdateCollectionMutation();
    const updateCollection = useCallback((collectionName, collectionData) => trigger({ collectionName, data: collectionData }).unwrap(), [trigger]);
    return {
        updateCollection,
        data,
        isLoading,
        isError,
        error,
    };
};
